export const useArrayToString = (arr) => {
  return arr?.length && arr?.join();
};
